export const ActionTypeEnum = {
	////
	snackbar: 'SETTINGS.SNACKBAR',
	loading: 'SETTINGS.LOADING',
	messages: 'SETTINGS.MESSAGES',
	error: 'ERROR',
	//
	home_categories_request: 'HOME_CATEGORIES_REQUEST',
	home_categories_success: 'HOME_CATEGORIES_SUCCESS',
	//
	search_categories_request: 'SEARCH_CATEGORIES_REQUEST',
	search_categories_success: 'SEARCH_CATEGORIES_SUCCESS',
	//
	sendSMS_request: 'HOME_SEND_SMS_REQUEST',
	sendSMS_success: 'HOME_SEND_SMS_SUCCESS',
	///
	sendSMS_request_landing: 'LANDING_SEND_SMS_REQUEST',
	sendSMS_success_landing: 'LANDING_SEND_SMS_SUCCESS',
	etma_registration_request_landing: 'LANDING_ETMA_REGISTRATION_REQUEST',
	etma_registration_success_landing: 'LANDING_ETMA_REGISTRATION_SUCCESS',
	etma_confirm_request_landing: 'LANDING_ETMA_CONFIRM_REQUEST',
	etma_confirm_success_landing: 'LANDING_ETMA_CONFIRM_SUCCESS',

	etma_resend_request_landing: 'LANDING_ETMA_RESEND_REQUEST',
	etma_resend_success_landing: 'LANDING_ETMA_RESEND_SUCCESS',
	//
	filter_request: 'SEARCH_FILTER_REQUEST',
	filter_success: 'SEARCH_FILTER_SUCCESS',
	//
	supplier_info_request: 'SUPPLIER_INFO_REQUEST',
	supplier_info_success: 'SUPPLIER_INFO_SUCCESS',
	//
	similar_suppliers_request: 'SIMILAR_SUPPLIERS_REQUEST',
	similar_suppliers_success: 'SIMILAR_SUPPLIERS_SUCCESS',
	//
	branch_request: 'BRANCH_REQUEST',
	branch_success: 'BRANCH_SUCCESS',
	//
	provinces_request: 'PROVINCE_REQUEST',
	province_success: 'PROVINCE_SUCCESS',
	filtered_cities_action: 'PROVINCE_CITY_FILTER',
	//
	widget_request: 'WIDGET_REQUEST',
	widget_success: 'WIDGET_SUCCESS',
	//
	contact_data_request: 'CONTACT_DATA_REQUEST',
	contact_data_success: 'CONTACT_DATA_SUCCESS',
	//
	installment_request: 'INSTALLMENT_REQUEST',
	installment_success: 'INSTALLMENT_SUCCESS',
	//
	organization_request: 'ORGANIZATION_REQUEST',
	organization_success: 'ORGANIZATION_SUCCESS',
	//
	merchant_request: 'MERCHANT_REQUEST',
	merchant_success: 'MERCHANT_SUCCESS',
};
